import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./Contact.css";
import { Share, Envelope, Telephone, GeoAlt, Linkedin, Github } from "react-bootstrap-icons";
import { motion } from "framer-motion";
import Navbar from "../../Hooks/Navbar/Navbar";
import usestyle from "../../Hooks/style/usestyle";
import PopupMessage from "../../Hooks/PopupMessage/PopupMessage";

const Contact = () => {
  const { variant } = usestyle();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    reciver: "mohammad_khattab@rexa4.com",
  });
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://www.rexa4.com/api/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setPopup({
          show: true,
          type: "success",
          message: "Message sent successfully!",
        });
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setPopup({
          show: true,
          type: "error",
          message: "Failed to send message: " + data.message,
        });
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setPopup({
        show: true,
        type: "error",
        message: "Error sending message. Please try again later.",
      });
    }
  };

  const handleClosePopup = () => {
    setPopup({ ...popup, show: false });
  };

  return (
    <>
      <Helmet>
        <title>Contact Mohammad Nour Khattab - Let's Work Together</title>
        <meta
          name="description"
          content="Get in touch with Mohammad Nour Khattab for web development projects, collaborations, or inquiries. Available for freelance work and full-time opportunities."
        />
        <meta
          name="keywords"
          content="Contact Developer, Hire Full Stack Developer, Web Development Services, Professional Developer Contact"
        />
        <link rel="canonical" href="https://nour-it.dev/contact" />
      </Helmet>
      <Navbar />
      <PopupMessage isVisible={popup.show} type={popup.type} message={popup.message} onClose={handleClosePopup} />
      <motion.div variants={variant} initial="initial" animate="animate" exit="exit" className="contact page">
        <div className="contener">
          <p className="span-line">CONTACT</p>
          <p className="big-header">CONTACT ME</p>
          <div className="content">
            {/* معلومات التواصل */}
            <div className="information">
              <div>
                <div className="m-icon">
                  <GeoAlt />
                </div>
                <div>
                  <span className="title"> My Address </span>
                  <p>UAE, Dubai</p>
                </div>
              </div>

              <div>
                <div className="m-icon">
                  <Share />
                </div>
                <div>
                  <span className="title"> Social Profiles</span>
                  <p>
                    <a
                      href="https://www.linkedin.com/in/mohammad-khattab-software-developer"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="LinkedIn"
                    >
                      <Linkedin />
                    </a>
                    <a href="https://github.com/Nour99988" target="_blank" rel="noopener noreferrer" title="GitHub">
                      <Github />
                    </a>
                  </p>
                </div>
              </div>

              <div>
                <div className="m-icon">
                  <Envelope />
                </div>
                <div>
                  <span className="title">Email Me</span>
                  <p>
                    <a href="mailto:m.nour.kh9346@gmail.com">m.nour.kh9346@gmail.com</a>
                  </p>
                </div>
              </div>

              <div>
                <div className="m-icon">
                  <Telephone />
                </div>
                <div>
                  <span className="title">Call Me</span>
                  <p>
                    <a href="tel:+971547809856">+971 54 780 9856</a>
                  </p>
                </div>
              </div>
            </div>

            {/* نموذج الإرسال */}
            <div className="form">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="email"
                  required
                />
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="subject"
                />
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
                <input type="submit" value="Send Message" className="submit" />
              </form>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Contact;
